// src/pages/Notification.jsx
import React, { useEffect, useState } from "react";
import { formateDateNumber, getCustomer } from "../include/function";
import { api, customerReqConfig } from "../include/api";
import Spinner from "./add-ons/Spinner";
import "../styles/Notification.css";

const Notification = () => {
  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotification = async () => {
      setLoading(true);
      const user = getCustomer();
      if (!user?.id) {
        setError("User not logged in");
        setLoading(false);
        return;
      }
      try {
        const response = await api.get(
          `/notification/?customerId=${user.id}`,
          customerReqConfig()
        );

        if (response.status === 200) {
          setNotification(response.data.data || []);
        } else {
          setNotification([]);
        }
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
        setError("Failed to load notifications");
        setNotification([]);
      } finally {
        setLoading(false);
      }
    };
    fetchNotification();
  }, []);

  const handleClearAll = async () => {
    const user = getCustomer();
    if (!user?.id) return;

    try {
      await api.delete(
        `/notification/?customerId=${user.id}`,
        {},
        customerReqConfig()
      );
      setNotification([]);
      alert("All notifications cleared!");
    } catch (err) {
      alert("Failed to clear notifications.");
    }
  };

  return (
    <div
      className="container border border-gray-100 rounded-16 px-40 py-40"
      style={{ marginTop: "200px", marginBottom: "50px" }}
    >
      {loading ? (
        <div className="text-center py-5">
          <Spinner />
          Loading notifications...
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : notification.length === 0 ? (
        <div className="text-center py-5 text-muted">No notifications yet.</div>
      ) : (
        <div className="notification-list w-100">
          
          <div className="d-flex justify-content-between align-items-center mb-14">
            <h6 className="mb-0 text-dark fw-bold fs-6">
              Notifications ({notification.length})
            </h6>
            <button className="" onClick={handleClearAll}>
              <h6 className="mb-0 text-dark fw-bold fs-6 clear-all-btn">
                Clear all
              </h6>
            </button>
          </div>

          {notification.map((note, index) => (
            <div
              key={note.id || note.createdTimestamp || index}
              className="notification-card mb-8 rounded border bg-white d-flex gap-3"
            >
              <div
                className="bell-icon-container"
                style={{
                  width: "70px",
                  height: "70px",
                }}
              >
                <i className="ph ph-bell bell-icon" />
              </div>

              <div className="flex-grow-1">
                <h6 className="text-dark fw-bold fs-6 mb-1">{note.body}</h6>
                <small className="notification-timestamp">
                  {formateDateNumber(note.createdTimestamp)}
                </small>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notification;
